import { createFileRoute } from '@tanstack/react-router'
import { CallsPage } from '@/features/calls/components/CallsPage'

export const Route = createFileRoute('/_auth/calls')({
  component: CallsPage,
})
